<template>
  <div class="register">
    <van-nav-bar
      :title="this.$route.query.wxopenid ? '绑定手机号' : '注册'"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      color="linear-gradient(to right, #ff9900, #ff3333)"
    />
    <div class="form">
      <van-cell-group>
        <van-field v-model="phone" placeholder="输入手机号" class="phone"/>
      </van-cell-group>
      <div class="password">
        <van-field v-model="verification" placeholder="输入验证码" type="number" class="pwd" />
        <van-button round type="info" color="linear-gradient(to right, #2fc7ff, #069EFF)" v-if="showVerification" @click="sendVerification">获取验证码</van-button>
        <van-button round type="info" color="linear-gradient(to right, #2fc7ff, #069EFF)" v-if="!showVerification">{{count}}S后刷新</van-button>
      </div>
      <p class="btn">
        <van-button
          round
          type="info"
          color="linear-gradient(to right, #ff9900, #ff3333)"
          @click="clickRegister"
        >{{ this.$route.query.wxopenid ? '绑定手机号' : '快速注册'   }}></van-button>
      </p>
      <p class="agreement">
        已阅读并同意以下协议：
        <router-link to="/agreement">优必上电商平台服务协议</router-link>
      </p>
    </div>
    <div class="frighet" v-if="frighetShow">
      <div class="content">
        <slide-verify
          :l="42"
          :r="10"
          :w="310"
          :h="155"
          @success="onSuccess"
          @fail="onFail"
          :show="false"
          :slider-text="text"
          :imgs="imgs"
        ></slide-verify>
       <!--  <slide-verify ref="slideblock" @success="onSuccess" @again="onAgain" @fulfilled="onFulfilled"
         @fail="onFail" @refresh="onRefresh" :slider-text="text" :imgs="imgs" :accuracy="accuracy"></slide-verify> -->
      </div>
      <img src="../assets/imgs/discernvcode_close_btn@2x.png" alt @click="frighetShow = false" />
    </div>
  </div>
</template>

<script>
import { Button, NavBar, Field,Cell, CellGroup } from "vant";
import img0 from '../assets/discernvcode_popbg_img1.png';
// import img1 from '../assets/discernvcode_popbg_img1.png';
// import img2 from '../assets/discernvcode_popbg_img1.png';
export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      //滑块验证
      msg: "",
      text: "拖动左边滑块完成验证",
      imgs: [img0],
      accuracy: 1, 
      frighetShow: false,
      verification:'',
      phone:'',
      showVerification: true,
      count: '',
      timer: null,
    };
  },
  methods: {
    // 获取验证码
    getVerifica(){
      // console.log('获取验证码')
      if(this.$route.query.wxopenid){
        let params = {
          appid:this.Encryp.appid,
          nonce:this.Encryp.nonce,
          phone:this.phone,
          timestamp:this.Encryp.timestamp,
          sign:this.$md5(`EZutTZ2alDhXrnstrAappid${this.Encryp.appid}nonce${this.Encryp.nonce}phone${this.phone}timestamp${this.Encryp.timestamp}EZutTZ2alDhXrnstrA`),
        };
        console.log(params)
        this.request.post("/v1/register/wx/sms", params)
        .then(res => {
            console.log(res);
        })
        .catch(err => {
            console.log(err);
        });
      }else{
        let params = {
          appid:this.Encryp.appid,
          nonce:this.Encryp.nonce,
          phone:this.phone,
          timestamp:this.Encryp.timestamp,
          sign:this.$md5(`EZutTZ2alDhXrnstrAappid${this.Encryp.appid}nonce${this.Encryp.nonce}phone${this.phone}timestamp${this.Encryp.timestamp}EZutTZ2alDhXrnstrA`),
        };
        console.log(params)
        this.request.post("/v1/register/sms", params)
        .then(res => {
            console.log(res);
        })
        .catch(err => {
            console.log(err);
        });
      }
      
    },
    //确认注册
    clickRegister(){
      this.register();
    },
    //验证手机号是否存在
    phoneIsUse(){
      if(!this.$route.query.wxopenid){
        let params = {
          appid:this.Encryp.appid,
          nonce:this.Encryp.nonce,
          phone:this.phone,
          timestamp:this.Encryp.timestamp,
          sign:this.$md5(`EZutTZ2alDhXrnstrAappid${this.Encryp.appid}nonce${this.Encryp.nonce}phone${this.phone}timestamp${this.Encryp.timestamp}EZutTZ2alDhXrnstrA`),
        };
        console.log(params)
        this.request.post("/v1/user/verifier", params)
        .then(res => {
            console.log(res);
            if(res.message =='查询成功'){
              this.$toast('手机号已注册')
              this.showVerification = true
              return false;
            }else{
              this.frighetShow = true
              // this.getVerifica();
              // this.$toast('发送成功');
              /* this.showVerification = false;
              setTimeout(()=>{
                this.showVerification = true
              },5000) */
            }
        })
        .catch(err => {
            console.log(err);
        });
      }else{
        this.frighetShow = true
        // this.getVerifica();
      }
      
    },
    // 注册
    register(){
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if(this.phone == ''){
        this.$toast('请先输入正确手机号');
        return;
      } else if (!reg.test(this.phone)) {
        this.$toast("手机号格式不正确，请重新输入");
        return;
      }
      if(this.verification == ''){
        this.$toast('请输入接收到的短信验证码');
        return;
      }
      if(this.$route.query.wxopenid){
        let params = {
          openid:this.$route.query.wxopenid,
          appid:this.Encryp.appid,
          unionid:this.$route.query.wxunionid,
          nonce:this.Encryp.nonce,
          phone:this.phone,
          smsCode:this.verification,
          timestamp:this.Encryp.timestamp,
          sign:this.$md5(`EZutTZ2alDhXrnstrAappid${this.Encryp.appid}nonce${this.Encryp.nonce}openid${this.$route.query.wxopenid}phone${this.phone}smsCode${this.verification}timestamp${this.Encryp.timestamp}unionid${this.$route.query.wxunionid}EZutTZ2alDhXrnstrA`),
        };
        console.log(params)
        let _this = this
        this.request.post("/v1/register/wx", params)
        .then(res => {
            console.log(res);
            if(res.code == 200){
              console.log(res);
              let paramswx = {
                openid:this.$route.query.wxopenid,
                appid:this.Encryp.appid,
                nonce:this.Encryp.nonce,
                unionid:this.$route.query.wxunionid,
                timestamp:this.Encryp.timestamp,
                sign:this.$md5(`EZutTZ2alDhXrnstrAappid${this.Encryp.appid}nonce${this.Encryp.nonce}openid${this.$route.query.wxopenid}timestamp${this.Encryp.timestamp}unionid${this.$route.query.wxunionid}EZutTZ2alDhXrnstrA`),
              };
              console.log(paramswx)
              this.request.post("/v1/login/wx", paramswx)
              .then(res => {
                  console.log(res);
                  _this.local.save('session',res.data.session.session)
                  this.$router.push('/')
              })
              .catch(err => {
                  console.log(err);
              });
            }else{
              this.$toast('注册失败')
            }
        })
        .catch(err => {
            console.log(err);
        });
      }else{
        let params = {
          appid:this.Encryp.appid,
          nonce:this.Encryp.nonce,
          phone:this.phone,
          smsCode:this.verification,
          timestamp:this.Encryp.timestamp,
          sign:this.$md5(`EZutTZ2alDhXrnstrAappid${this.Encryp.appid}nonce${this.Encryp.nonce}phone${this.phone}smsCode${this.verification}timestamp${this.Encryp.timestamp}EZutTZ2alDhXrnstrA`),
        };
        console.log(params)
        let _this = this
        this.request.post("/v1/register/phone", params)
        .then(res => {
            console.log(res);
            if(res.code == 200){
              _this.$router.push('login')
            }else{
              this.$toast(res.message)
            }
        })
        .catch(err => {
            console.log(err);
        });
      }
      
    },
    onClickLeft() { this.$router.go(-1)   },//返回上一层
    //滑块验证
    onSuccess() {
      this.$toast('验证成功');
      this.frighetShow = false

      this.getVerifica()//获取验证码
      // this.register();//注册
    },
    onFail() { 
      this.$toast('验证失败') 
      this.showVerification = true
    },
    /* onRefresh() { 
      this.msg = ""
      this.showVerification = true
    }, */
    
    sendVerification(){
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if(this.phone == ''){
        this.$toast('请先输入手机号');
      } else if (!reg.test(this.phone)) {
        this.$toast("手机号格式不正确，请重新输入");
      } else{
       this.phoneIsUse()
        this.getCode()
      }
      // this.frighetShow = true
    },
    getCode(){
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showVerification = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            } else {
            this.showVerification = true;
            clearInterval(this.timer);
            this.timer = null;
            }
        }, 1000)
      }
    },
    /* immRegister(){
      this.frighetShow = true
    } */
  },
  created(){
    
  }
};
</script>

<style lang="less" scoped>
.register {
  .van-nav-bar {
    background: linear-gradient(to right, #ff9900, #ff3333);
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title {
      color: #fff;
    }
    .van-nav-bar__title{
        font-weight: bold;
        font-size: 1.25rem;
    }
  }
  .form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 3rem;
    .van-cell {
      border: 1px solid #ccc;
      border-radius: 1.5rem;
      line-height: 1.5rem;
      width: 20rem;
      margin-bottom: 2rem;
    }
    .password {
      display: flex;
      .pwd {
        width: 13rem;
      }
      .van-button {
        margin-left: 1rem;
        width: 6rem;
        font-size: 0.8rem;
      }
    }
    .btn {
      .van-button {
        border-radius: 1.5rem;
        line-height: 1.5rem;
        width: 14rem;
        margin-top: 0.5rem;
        font-size: 1rem;
        word-spacing: 0.5rem;
        margin-top: 2rem;
      }
    }
    .agreement {
      width: 18rem;
      color: #333;
      font-size: 0.6rem;
      margin-top: 1rem;
      a {
        color: #ff3333;
        font-weight: bold;
        text-decoration: underline;
      }
    }
  }
  //验证码弹窗
  .frighet {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000000;
    display: flex;
    align-items: center;
    flex-direction: column;

    .content {
      width: 21rem;
      height: 15rem;
      z-index: 10000000;
      background: #fff;
      margin-top: 8rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    //   /deep/ .slide-verify-slider-mask-item {
    //     border-radius: 20px;
    //     background: url("../assets/imgs/discernvcode_slider_btn@2x.png");
    //   }
    //   /deep/ .slide-verify-slider {
    //     border-radius: 20px;
    //   }
    //   /deep/ .container-success .slide-verify-slider-mask{
    //       border-radius: 16px;
    //   }
    }
    img {
      width: 4rem;
      height: 4rem;
      margin-top: 1rem;
    }
  }
}
</style>